
import { defineComponent, ref, useContext } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    additionalCostDescription: { type: String, required: false, default: '' },
    beverages: { type: Boolean, required: false, default: false },
    hasVriendenloterijTicketType: { type: Boolean, required: false, default: false },
  },
  setup({ additionalCostDescription, beverages }) {
    const {
      app: { i18n },
    } = useContext()

    const items = ref([
      {
        label: i18n.t('concert.detail.bevarages-included-title'),
        description: beverages ? i18n.t('concert.detail.bevarages-included') : i18n.t('concert.detail.bevarages-excluded'),
      },
      {
        label: i18n.t('concert.detail.additional-costs-title'),
        description: additionalCostDescription || i18n.t('concert.detail.additional-costs'),
      },
    ])

    return {
      items,
    }
  },
})
